/** Da Vinci PAS / backend canonical URLs (prior-auth-service test bundles + PasProfiles). */
export const PAS_FHIR_URLS = {
  FULL_URL_BASE: "https://demo.fhir.aaneelconnect.com",
  CLAIM_PROFILE:
    "http://hl7.org/fhir/us/davinci-pas/StructureDefinition/profile-claim",
  CARE_TEAM_CLAIM_SCOPE:
    "http://hl7.org/fhir/us/davinci-pas/StructureDefinition/extension-careTeamClaimScope",
  SUPPORTING_INFO_TYPE:
    "http://hl7.org/fhir/us/davinci-pas/CodeSystem/PASClaimSupportingInfoType",
  CERTIFICATION_TYPE_CS:
    "http://hl7.org/fhir/us/davinci-pas/CodeSystem/CertificationTypeCS",
  ADMISSION_TYPE_CS:
    "http://hl7.org/fhir/us/davinci-pas/CodeSystem/AdmissionTypeCS",
  NPI: "http://hl7.org/fhir/sid/us-npi",
  ICD10_CM: "http://hl7.org/fhir/sid/icd-10-cm",
  CPT: "http://www.ama-assn.org/go/cpt",
  CMS_POS: "https://www.cms.gov/medicare/coding/place-of-service-codes",
  COVERAGE_CLASS: "http://terminology.hl7.org/CodeSystem/coverage-class",
  CLAIM_TYPE: "http://terminology.hl7.org/CodeSystem/claim-type",
  PROCESS_PRIORITY: "http://terminology.hl7.org/CodeSystem/processpriority",
  NUCC_TAXONOMY: "http://nucc.org/provider-taxonomy",
  CLAIM_CARE_TEAM_ROLE: "http://terminology.hl7.org/CodeSystem/claimcareteamrole",
  PRIOR_AUTH_ID: "https://aaneel.com/priorauth",
};

export function pasFullUrl(resourceType, id) {
  return `${PAS_FHIR_URLS.FULL_URL_BASE}/${resourceType}/${id}`;
}

/** Build supportingInfo category coding (PasBundleMapper.MatchesSupportingInfoCategory). */
export function pasSupportingInfoCategory(code, display) {
  return {
    coding: [
      {
        system: PAS_FHIR_URLS.SUPPORTING_INFO_TYPE,
        code,
        ...(display ? { display } : {}),
      },
    ],
  };
}
